<template>
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row mb-12">
                <div class="col">
                    <div class="page-title-nav row">
                        <div class="col-2 col-lg-3">
                            <a href="#" class="btn btn-outline-secondary btn-custom btn-back"><i
                                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span></a>
                        </div>
                        <div class="col-8 col-lg-6">
                            <h1 class="page-title">หวยยี่กีวิเดียว</h1>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a href="#" class="btn btn-primary btn-custom d-none"><i
                                    class="fa-icon fa-regular fa-home"></i><span>button</span></a>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-6 d-grid">
                            <a  class="btn btn-label-secondary btn-custom btn-xl border-0"><i
                                    class="fa-icon fa-regular fa-list-ol d-none d-lg-inline-block"></i>ร่วมออกผลรางวัล</a>
                        </div>
                        <div class="col-6 d-grid">
                            <router-link :to="'/member/lotto'" class="btn btn-outline-secondary btn-custom btn-xl">
                                <i
                                class="fa-icon fa-regular fa-input-numeric d-none d-lg-inline-block"></i>หน้าแทง
                            </router-link>
                        </div>
                    </div>
                    <div class="row mb-5" v-if="getYeekiInfo.status==4 && getYeekiInfo.status != ''">
                        <div class="col-12 ">
                            <div class="content-card">
                                <div class="content-card-title d-flex justify-content-between">
                                    {{ getYeekiInfo ? getYeekiInfo.group_name : ''  }} - {{ getYeekiInfo.title }}
                                </div>
                                <div class="content-card-body text-center">
                                    <span style="font-size:100px;line-height:1.2;"><i class="fas fa-spinner fa-spin text-danger"></i></span>
                                    <h4 class="text-danger" style="font-family:inherit"> ยกเลิกรอบเนื่องจากยอดการยิงเลขมีไม่ถึง 20 ลำดับ </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <div class="content-card mb-4">
                                <div class="content-card-title d-flex justify-content-between">
                                    <span>{{ getYeekiInfo ? getYeekiInfo.group_name : ''  }} - {{ getYeekiInfo.title }}</span><a  v-b-modal.rule-yeekee type="button" class="btn btn-outline-secondary btn-sm"
                                        data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top">
                                        <i  class="fa-icon fa-regular fa-circle-info"></i>อัตราจ่าย</a>
                                </div>
                                <div class="content-card-body">
                                    <p class="text-center"><strong>งวดวันที่  {{ getDate(getYeekiInfo.date.round_date)}}</strong></p>
                                    <div class="alert alert-success d-flex" role="alert">
                                        <i class="fa-icon fa-solid fa-circle-info mt-1 me-2"></i>ผลออกแล้ว
                                    </div>
                                    <div class="lotto-yeekee-prizes mb-4">
                                        <div class="content-top">
                                            <h5 class="label">ผลรางวัล</h5>
                                            <h3 class="result"> {{ reward.prefix }}<span>{{ reward.twoUp }}</span>{{ reward.treeUp }}</h3>
                                            <button type="button" class="btn btn-primary btn-icon btn-sm"
                                                data-bs-toggle="tooltip" data-bs-placement="top"
                                                title="Tooltip on top"><i
                                                    class="fa-icon fa-regular fa-circle-info m-0"></i></button>
                                        </div>
                                        <div class="content-bottom">
                                            <div class="d-flex justify-content-between">
                                                <span class="label">ผลรวม</span>
                                                <span class="result">{{ listPush.sum }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <span class="label">เลขอันดับที่ 16</span>
                                                <span class="result">    {{ listPush.description.recond_16.num }} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="lotto-yeekee-prizes-table">
                                        <div class="row m-0">
                                            <!-- <div class="col-4 p-0 d-flex">
                                                <div class="table-cell">
                                                    <span class="label">สี่ตัวบน</span>
                                                    <span class="result">9999</span>
                                                </div>
                                            </div> -->
                                            <div class="col-4 p-0 d-flex">
                                                <div class="table-cell">
                                                    <span class="label">สามตัวบน</span>
                                                    <span class="result">{{ reward.treeUp }}</span>
                                                </div>
                                            </div>
                                            <div class="col-4 p-0 d-flex">
                                                <div class="table-cell border-end-0">
                                                    <span class="label">สองตัวล่าง</span>
                                                    <span class="result">{{ reward.twoUp }}</span>
                                                </div>
                                            </div>
                                            <div class="col-6 p-0 d-flex">
                                                <div class="table-cell">
                                                    <span class="label">ผลรวม</span>
                                                    <span class="result">{{ listPush.sum }}</span>
                                                </div>
                                            </div>
                                            <div class="col-6 p-0 d-flex">
                                                <div class="table-cell border-end-0">
                                                    <span class="label">เลขอันดับที่ 16</span>
                                                    <span class="result">{{ listPush.description.recond_16.num }} </span>
                                                </div>
                                            </div>
                                            <div class="col-12 p-0">
                                                <div class="table-cell flex-row justify-content-between pb-1 border-0">
                                                    <span class="label">ผู้ส่งเลขอันดับที่ 1</span>
                                                    <span class="result">{{ getNameDecode(listPush.description.recond_1.name) }} </span>
                                                </div>
                                                <div class="table-cell flex-row justify-content-between pt-1 border-0">
                                                    <span class="label">ผู้ส่งเลขอันดับที่ 16</span>
                                                    <span class="result">{{ getNameDecode(listPush.description.recond_16.name) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-9">
                            <div class="content-card">
                                <div class="content-card-title d-flex justify-content-between">
                                    <span>ผู้ส่งเลข</span>
                                    <!-- <button type="button" class="btn btn-outline-secondary btn-sm"
                                        data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top"><i
                                            class="fa-icon fa-regular fa-file-arrow-down"></i>ดาวน์โหลด</button> -->
                                </div>
                                <div class="content-card-title user-id">
                                    <span class="user-id">ชื่อผู้ใช้ของฉัน<strong
                                            class="text-primary ms-2">{{ getUsername }}</strong></span>
                                </div>
                                <div class="content-card-body p-0">
                                    <div class="row m-0">
                                        <div class="col-12 col-md-6 p-0">
                                            <template v-for="(item, index) in listPush.lists"  >
                                            <div :key="index" v-if="index < 10">
                                            <div  v-if="isWin(index)"  class="lotto-yeekee-result-item primary" >
                                                <span class="badge">{{ ((listPush.page - 1) * listPush.count) + index + 1 }}</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">{{ getNameDecode(item.name) }}</span>
                                                        <span class="timestamp">{{ item.date }}</span>
                                                    </div>
                                                    <strong class="lotto-number">{{ item.num }}</strong>
                                                </div>
                                            </div>
                                            <div :key="index" v-else class="lotto-yeekee-result-item" >
                                                <span class="badge">{{ ((listPush.page - 1) * listPush.count) + index + 1 }}</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">{{ getNameDecode(item.name) }}</span>
                                                        <span class="timestamp">{{ item.date }}</span>
                                                    </div>
                                                    <strong class="lotto-number">{{ item.num }}</strong>
                                                </div>
                                            </div>
                                        </div>
                                        </template>
                                            <!-- <div class="lotto-yeekee-result-item">
                                                <span class="badge">2</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">0485#2</span>
                                                        <span class="timestamp">21:29:59.824</span>
                                                    </div>
                                                    <strong class="lotto-number">129498</strong>
                                                </div>
                                            </div>
                                            <div class="lotto-yeekee-result-item">
                                                <span class="badge">3</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">0485#2</span>
                                                        <span class="timestamp">21:29:59.824</span>
                                                    </div>
                                                    <strong class="lotto-number">129498</strong>
                                                </div>
                                            </div> -->
                                        </div>
                                        <div class="col-12 col-md-6 p-0">
                                            <template v-for="(item, index) in listPush.lists"  >
                                            <div :key="index" v-if="index >9">
                                            <div  v-if="isWin(index)"  class="lotto-yeekee-result-item primary" >
                                                <span class="badge">{{ ((listPush.page - 1) * listPush.count) + index + 1 }}</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">{{ getNameDecode(item.name) }}</span>
                                                        <span class="timestamp">{{ item.date }}</span>
                                                    </div>
                                                    <strong class="lotto-number">{{ item.num }}</strong>
                                                </div>
                                            </div>
                                            <div :key="index" v-else class="lotto-yeekee-result-item" >
                                                <span class="badge">{{ ((listPush.page - 1) * listPush.count) + index + 1 }}</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">{{ getNameDecode(item.name) }}</span>
                                                        <span class="timestamp">{{ item.date }}</span>
                                                    </div>
                                                    <strong class="lotto-number">{{ item.num }}</strong>
                                                </div>
                                            </div>
                                        </div>
                                        </template>
                                            <!-- <div class="lotto-yeekee-result-item">
                                                <span class="badge">18</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">0485#2</span>
                                                        <span class="timestamp">21:29:59.824</span>
                                                    </div>
                                                    <strong class="lotto-number">129498</strong>
                                                </div>
                                            </div>
                                            <div class="lotto-yeekee-result-item info">
                                                <span class="badge">19</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">0485#2</span>
                                                        <span class="timestamp">21:29:59.824</span>
                                                    </div>
                                                    <strong class="lotto-number">129498</strong>
                                                </div>
                                            </div>
                                            <div class="lotto-yeekee-result-item">
                                                <span class="badge">20</span>
                                                <div class="content flex-grow-1">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-id">0485#2</span>
                                                        <span class="timestamp">21:29:59.824</span>
                                                    </div>
                                                    <strong class="lotto-number">129498</strong>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                <b-pagination class="pagination pagination-sm justify-content-center mt-2"
               style="z-index: 0;"
                      v-model="page"
                      :total-rows="listPush.count * listPush.max_page"
                      :per-page="listPush.count"
                    ></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="push">
                <app-rule-yeekee-modal />
            </div>
        </div>
    </div>
</template>

<script>
import ruleYeekeeModal from '@/components/modals/RuleYeekeeModal'
import { mapGetters, mapActions } from 'vuex'
import { getRuleByID, listPushNumberYeekee } from '@/services'
import moment from 'moment'
export default {
  components: {
    'app-rule-yeekee-modal': ruleYeekeeModal
  },
  async created () {
    this.setLoading(true)
    this.roundID = this.$route.params.id
    this.catalogId = this.$route.params.catalog
    if (this.$route.params.page > 0) {
      this.page = this.$route.params.page
    } else {
      this.page = 1
    }
    try {
      await this.getYeekiInfomationByRoundId(this.$route.params.id)
      if (Number(this.getYeekiInfo.status) === 0 || Number(this.getYeekiInfo.status) === 1) {
        // this.$router.replace(`/member/lottery/yeeki-fire/${this.catalogId}/${this.roundID}`)
      } else if (Number(this.getYeekiInfo.status) === 3) {
        await this.fetchResultLotto(this.$route.params.id)
      }
      const resp = await getRuleByID(this.roundID)
      if (resp.status_code === 'SUCCESS') {
        this.pathImage = resp.data.pathImage
      }
      this.setLoading(true)
      await this.listPushNumber()
      this.setLoading(false)
    } catch (error) {
      this.setLoading(false)
    }
  },
  data: () => {
    return {
      page: 1,
      title: '',
      info: {},
      roundID: '',
      catalogId: '',
      pathImage: '',
      listPush: {
        count: 0,
        description: {
          recond_1: { name: '', num: '' },
          recond_16: { name: '', num: '' }
        },
        index_win: [],
        lists: [],
        listsIsWin: [],
        max_page: 0,
        page: 1,
        sum: 0
      },
      reward: {
        prefix: 'XXX',
        twoUp: 'XX',
        treeUp: 'XXX'
      }
    }
  },
  methods: {
    ...mapActions(['setLoading', 'fetchResultLotto', 'getYeekiRound', 'getYeekiCatalog', 'getYeekiInfomationByRoundId']),
    async listPushNumber () {
      const resp = await listPushNumberYeekee({ roundID: parseInt(this.roundID), page: parseInt(this.page) })
      if (resp.status_code === 'SUCCESS') {
        this.listPush = resp.data
        const sum = (this.listPush.sum - this.listPush.description.recond_16.num) + ''
        this.reward.prefix = sum.substring(0, sum.length - 5)
        this.reward.treeUp = sum.substring(sum.length - 3, sum.length)
        this.reward.twoUp = sum.substring(sum.length - 5, sum.length - 3)
      }
    },
    getNameDecode (name) {
      /* Format XX***XX */
      return name.substring(0, 2) + '***' + name.substring(name.length - 2, name.length)
    },
    isWin (index) {
      return this.listPush.index_win.includes(((this.listPush.page - 1) * this.listPush.count) + index)
    },
    getPreviousClass (index) {
      return (this.page === 1) ? 'disabled' : ''
    },
    getDate (originalDate) {
      const date = new Date(originalDate)
      // Format to Thai locale date
      return date.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      })
    },
    // getTime (originalTime) {
    //   console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>originalTime>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
    //   console.log(moment(originalTime))
    //   console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>originalTime>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')

    //   // Format to Thai locale date
    //   return originalTime
    // },
    getTime (time) {
      const timer = moment(time)
      const min = timer.minutes().toString()
      const hour = timer.hours().toString()
      const pad = '00'
      const minCal = pad.substring(0, pad.length - min.length) + min
      const hourCal = pad.substring(0, pad.length - hour.length) + hour

      return `${hourCal}: ${minCal}`
    }
  },
  computed: {
    ...mapGetters(['getResultLotto', 'getYeekiCatalogList', 'getYeekiInfo', 'getUsername']),
    rows () {
      return this.items.length
    }
  },
  watch: {
    page: function (value) {
      this.listPushNumber()
    }
  }
}
</script>
